const createRootStylesheet = () => {
  const isSameDomain = ({ href }) =>
    !href ? true : href.startsWith(location.origin);
  const isRootStyleRule = rule =>
    rule instanceof CSSStyleRule && rule.selectorText.includes(':root');
  const isCustomRule = ([propName]) => propName.startsWith('--');

  const getCSSCustomPropEntries = () => {
    const localStyleSheets = [...document.styleSheets].filter(isSameDomain);
    return localStyleSheets.reduce(
      (_customPropsEntries, { cssRules }) => [
        ...[...cssRules]
          .filter(isRootStyleRule)
          .reduce((_sheetRules, { style, styleMap }) => {
            let ruleEntries;
            if (styleMap) ruleEntries = [...styleMap.entries()];
            else {
              ruleEntries = [...style].map(propName => [
                propName.trim(),
                style.getPropertyValue(propName).trim(),
              ]);
            }
            let ruleCustomProps = ruleEntries
              .filter(isCustomRule)
              .filter(([newPropName]) => {
                return !_sheetRules.some(
                  ([existingPropName]) => newPropName === existingPropName
                );
              });
            return [..._sheetRules, ...ruleCustomProps];
          }, []),
        ..._customPropsEntries,
      ],
      []
    );
  };

  const createStylesheet = () => {
    const rootStylesheet = new CSSStyleSheet();
    const styles = getCSSCustomPropEntries().reduce((_rules, [prop, value]) => {
      _rules += `${prop}: ${value};`;
      return _rules;
    }, '');
    rootStylesheet.replaceSync(`:root, :host { ${styles} }`);
    document.adoptedStyleSheets = [rootStylesheet];
    return rootStylesheet;
  };

  return createStylesheet();
};

class Root {
  static stylesheet = window.Root ? window.Root.stylesheet : createRootStylesheet();

  static get #style() {
    return Root.stylesheet.cssRules[0].style;
  }

  static getStyle(prop) {
    return Root.#style.getPropertyValue(prop);
  }

  static setStyle(prop, value) {
    Root.#style.setProperty(prop, value);
    return Root.getStyle(prop);
  }
}
export default Root;
